// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3HmEQ","approved":"Status_approved__205GY","rejected":"Status_rejected__1z7Fp","expired":"Status_expired__1K7Or","label":"Status_label__28eFS"};